const { fetchWithRetry } = require("./utils");

const createContestant = async (contestantData) => {
    try {
        const response = await fetchWithRetry('/api/contestants', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(contestantData),
        });

        if (!response.ok) {
            throw new Error(`Error creating contestant: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating contestant:', error);
        throw error;
    }
};

const searchContestants = async ({ page = 1, pageSize = 10, filters = {}, searchText = "" } = {}) => {  
    let url = `/api/contestants/search?page=${page}&pageSize=${pageSize}`;  
    if (filters.round) url += `&round=${filters.round}`;  
    if (filters.province) url += `&province=${filters.province}`;  
    if (searchText && searchText.length) url += `&searchText=${encodeURIComponent(searchText)}`;  
    const response = await fetchWithRetry(url, { method: "GET", headers: { "Content-Type": "application/json" } });  
    if (!response.ok) throw new Error(`Error searching contestants: ${response.statusText}`);  
    return await response.json();  
};   

const deleteContestant = async (contestantId) => {
    try {
        const response = await fetchWithRetry(`/api/contestants/${contestantId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error deleting contestant: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting contestant:', error);
        throw error;
    }
};

const updateCreatedByWithContestantCode = async (contestantCode) => {
    try {
        const response = await fetchWithRetry(`/api/contestants/code/${contestantCode}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error updating contestant: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating contestant:', error);
        throw error;
    }
};

const updateContestantRound = async (contestantId, roundNumber) => {  
    try {  
        const response = await fetchWithRetry(`/api/contestants/${contestantId}/round/${roundNumber}`, {  
            method: 'PATCH',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
        });  

        if (!response.ok) {  
            throw new Error(`Error updating contestant round: ${response.statusText}`);  
        }  
        return await response.json();  
    } catch (error) {  
        console.error('Error updating contestant round:', error);  
        throw error;  
    }  
};  

const updateContestantDetails = async (contestantId, updates) => {  
    try {  
        const response = await fetchWithRetry(`/api/contestants/${contestantId}`, {  
            method: 'PATCH',  
            headers: {  
                'Content-Type': 'application/json',  
            },  
            body: JSON.stringify(updates),
        });  
  
        if (!response.ok) {  
            throw new Error(`Error updating contestant details: ${response.statusText}`);  
        }  
  
        return await response.json();  
    } catch (error) {  
        console.error('Error updating contestant details:', error);  
        throw error;  
    }  
};  

const downloadProfilePhoto = async (contestantId) => {  
    const response = await fetch(`/api/contestants/${contestantId}/profile-photo`, {  
      method: 'GET',  
    });  
    if (!response.ok) {  
      throw new Error('Could not download profile photo');  
    }  
    const blob = await response.blob();  
    return blob;  
  };  

  const updateContestantProvince = async (contestantId, provinceId) => {
    const response = await fetch(`/api/contestants/${contestantId}/province`, {
        method: "PUT",
        headers: {
        "Content-Type": "application/json",
        // add auth header if needed
        },
        body: JSON.stringify({ provinceId }),
    });

    if (!response.ok) {
        throw new Error("Failed to update contestant province");
    }

    return response.json();
};

module.exports = {
    createContestant,
    searchContestants,
    deleteContestant,
    updateCreatedByWithContestantCode,
    updateContestantRound,
    updateContestantDetails,
    downloadProfilePhoto,
    updateContestantProvince
};  